import React from "react";
import { Col } from "antd";

const Description = ({ term, children, col = 8, ...rest }) => {
  return (
    <Col span={col}>
      <span className="title">{term}：</span>
      <span>{children && children !== "0" ? children : ""}</span>
    </Col>
  );
};

export default Description;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/Description.js